import styled from '@emotion/styled';

import { css } from '@emotion/react';
import {
    mediaQuery,
    breakpoints,
    gutterSizes,
    fontSizes,
} from '@gumtree/ui-library/src/base/theme';
import { newLayout } from '../../app.style';

export const Title = styled.h2<{ isMobileCardsLayout: boolean }>`
    ${mediaQuery.until(breakpoints.small)} {
        display: none;
    }
    margin-bottom: 0;
    margin-right: ${gutterSizes.base};
    font-size: 17px;

    ${({ isMobileCardsLayout }) =>
        isMobileCardsLayout &&
        css`
            ${mediaQuery.until(breakpoints.small)} {
                display: block;
            }
        `}
`;

export const SharePanelLabel = styled.span`
    display: none;
`;

export const SharePanelItems = styled.ul`
    flex-grow: 1;
    display: flex;
    justify-content: flex-end;

    ${mediaQuery.until(breakpoints.small)} {
        justify-content: space-evenly;
    }

    & .icon {
        font-size: 30px;

        ${mediaQuery.until(breakpoints.small)} {
            font-size: ${fontSizes.iconLarge};
        }
    }
`;

export const SharePanelContainer = styled.div<{
    isMobileCardsLayout: boolean;
}>`
    display: flex;
    align-items: center;

    ${mediaQuery.until(breakpoints.medium)} {
        text-align: center;
    }

    li {
        display: inline-block;
        padding: 0 ${gutterSizes.base};

        ${mediaQuery.until(breakpoints.small)} {
            padding: 0 ${gutterSizes.xsmall};
        }
    }

    ${({ isMobileCardsLayout }) =>
        isMobileCardsLayout &&
        css`
            ${newLayout};
        `}
`;
